export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8936.a86abb10.jpg";